// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"66712ce4","126":"a017872d","162":"edc7d8c5","171":"dae0b817"}[chunkId] + ".chunk.js";
};